import { put, call } from 'redux-saga/effects'
import { delay } from 'redux-saga'
import { startSubmit, stopSubmit, reset, setSubmitFailed, stopAsyncValidation } from 'redux-form'
import * as colors from 'material-ui/styles/colors';

import * as commons from '../commons'
import * as actions from '../actions'

import moment from 'moment'

function* getList(masterType, page, form) {
  const res = yield call(commons.post2, `/bg/master/${masterType}/search?page=${page}`, form) 
  return res
}

function* errorCheck(masterType, res) {

  if (!res) {
    yield put(stopSubmit(`${masterType}MasterForm`))
    yield put(actions.reducerSnackBar(true, '通信処理に失敗しました。', colors.red400))
    yield put(actions.reducerAppLoading(false))
    return
  }

  if (res.status && res.status == 401) {
    yield put(stopSubmit(`${masterType}MasterForm`))
    yield put(actions.reducerSnackBar(true, 'セッションタイムアウト（30分）しました。', colors.red400))
    yield put(actions.reducerSetAuth({}, 9))
    yield put(actions.reducerAppLoading(false))
    return
  }

  if (res.fetchError || (res.status && res.status != 200)) {
    yield put(stopSubmit(`${masterType}MasterForm`))
    yield put(actions.reducerSnackBar(true, '通信処理に失敗しました。', colors.red400))
    yield put(actions.reducerAppLoading(false))
    return false
  }
  
  if (res.error) {
    const {field, message} = res.error
    yield put(stopSubmit(`${masterType}MasterForm`, { ...field}))
    yield put(actions.reducerSnackBar(true, message, colors.red400))
    yield put(actions.reducerAppLoading(false))
    return false
  }

  return true
}

export function* handleMasterInit(action) {

  const {masterType} = action.payload

  yield put(actions.reducerMasterInit(masterType))

  yield put(actions.reducerAppLoading(true))

  if (masterType === 'department') {
    const branchOfficeRes = yield call(commons.get2, `/bg/master/branchOffice`)
    const check = yield call(errorCheck, masterType, branchOfficeRes)
    if (!check) {
      return
    }
    yield put(actions.reducerMasterSetSelectData(masterType, 
      Object.assign({}, {branchOffice: branchOfficeRes.result.list})))
  }

  if (masterType === 'user') {
    const branchOfficeRes = yield call(commons.get2, `/bg/master/branchOffice`)
    const branchOfficeResCheck = yield call(errorCheck, masterType, branchOfficeRes)
    if (!branchOfficeResCheck) {
      return
    }
    const departmentRes = yield call(commons.get2, `/bg/master/department`)
    const departmentResCheck = yield call(errorCheck, masterType, departmentRes)
    if (!departmentResCheck) {
      return
    }
    const priceRes = yield call(commons.get2, `/bg/master/price`)
    const priceResCheck = yield call(errorCheck, masterType, priceRes)
    if (!priceResCheck) {
      return
    }
    yield put(actions.reducerMasterSetSelectData(masterType, 
      Object.assign({}, 
        {
          branchOffice: branchOfficeRes.result.list,
          department: departmentRes.result.list,
          price: priceRes.result.list,
        }
    )))
  }

  if (masterType === 'overTime') {
    const branchOfficeRes = yield call(commons.get2, `/bg/master/branchOffice`)
    const branchOfficeResCheck = yield call(errorCheck, masterType, branchOfficeRes)
    if (!branchOfficeResCheck) {
      return
    }
    const departmentRes = yield call(commons.get2, `/bg/master/department`)
    const departmentResCheck = yield call(errorCheck, masterType, departmentRes)
    if (!departmentResCheck) {
      return
    }

    yield put(actions.reducerMasterSetSelectData(masterType, 
      Object.assign({}, 
        {
          branchOffice: branchOfficeRes.result.list,
          department: departmentRes.result.list,
        }
    )))
  }


  if (masterType === 'kenmei') {
    const branchOfficeRes = yield call(commons.get2, `/bg/master/branchOffice`)
    const branchOfficeResCheck = yield call(errorCheck, masterType, branchOfficeRes)
    if (!branchOfficeResCheck) {
      return
    }
    const departmentRes = yield call(commons.get2, `/bg/master/department`)
    const departmentResCheck = yield call(errorCheck, masterType, departmentRes)
    if (!departmentResCheck) {
      return
    }
    const customerRes = yield call(commons.get2, `/bg/master/customer`)
    const customerResCheck = yield call(errorCheck, masterType, customerRes)
    if (!customerResCheck) {
      return
    }
    const constructionRes = yield call(commons.get2, `/bg/master/construction`)
    const constructionResCheck = yield call(errorCheck, masterType, constructionRes)
    if (!constructionResCheck) {
      return
    }
    yield put(actions.reducerMasterSetSelectData(masterType, 
      Object.assign({}, 
        {
          branchOffice: branchOfficeRes.result.list,
          department: departmentRes.result.list,
          customer: customerRes.result.list,
          construction: constructionRes.result.list,
        }
    )))
  }

  if (masterType === 'roumu') {
    const branchOfficeRes = yield call(commons.get2, `/bg/master/branchOffice`)
    const branchOfficeResCheck = yield call(errorCheck, masterType, branchOfficeRes)
    if (!branchOfficeResCheck) {
      return
    }
    const departmentRes = yield call(commons.get2, `/bg/master/department`)
    const departmentResCheck = yield call(errorCheck, masterType, departmentRes)
    if (!departmentResCheck) {
      return
    }
    yield put(actions.reducerMasterSetSelectData(masterType, 
      Object.assign({}, 
        {
          branchOffice: branchOfficeRes.result.list,
          department: departmentRes.result.list,
        }
    )))
  }

  let form = action.payload.form
  let page = action.payload.page || 1

  if (form == undefined && window.localStorage) {
    const localStorageForm = window.localStorage.getItem(masterType)
    if (localStorageForm) {
      form = JSON.parse(localStorageForm)
    } else {
      form = {}
    }
  }


  let res
  if (masterType == 'roumu') {
    res = yield call(commons.post2, `/bg/roumu/approval/search?page=${page}`, form)
  } else {
    res = yield call(getList, masterType, page, form)
  }

  const check = yield call(errorCheck, masterType, res)
  if (!check) {
    return
  }

  yield put(actions.reducerMasterSetList(masterType, res.result, form, page))

  yield call(delay, 100)

  yield put(actions.reducerAppLoading(false))

}

export function* handleMasterGetList(action) {

  yield put(actions.reducerAppLoading(true))

  const {masterType, page} = action.payload

  let res
  if (masterType == 'roumu') {
    res = yield call(commons.post2, `/bg/roumu/approval/search?page=${page}`, {}) 
  } else {
    res = yield call(getList, masterType, page)
  }

  const check = yield call(errorCheck, masterType, res)
  if (!check) {
    return
  }

  yield put(actions.reducerMasterSetList(masterType, res.result))

  yield put(actions.reducerAppLoading(false))

}


export function* handleMasterFormRegist(action) {

  const {masterType, id, form, page, tmpForm} = action.payload
  
  yield put(startSubmit(`${masterType}MasterForm`))
  yield put(actions.reducerAppLoading(true))

  let registRes;

  if (masterType == "password") {
      registRes = yield call(commons.post2, `/bg/master/user/updatePassword/`, form) 
      const registCheck = yield call(errorCheck, masterType, registRes)
      if (!registCheck) {
        return
      }

      yield put(actions.reducerMasterSetForm(masterType, {rand: moment().unix()}))

      yield put(stopSubmit(`${masterType}MasterForm`))

      yield put(actions.reducerSnackBar(true, '登録しました。', colors.green400))
      yield put(actions.reducerAppLoading(false))

      return
  } else {

    if (id) {
      registRes = yield call(commons.put2, `/bg/master/${masterType}/${id}`, form) 
    } else {
      registRes = yield call(commons.post2, `/bg/master/${masterType}`, form) 
    }

  }

  const registCheck = yield call(errorCheck, masterType, registRes)
  if (!registCheck) {
    return
  }

  const listRes = yield call(getList, masterType, page, tmpForm) 

  const listCheck = yield call(errorCheck, masterType, listRes)
  if (!listCheck) {
    return
  }

  yield put(actions.reducerMasterSetList(masterType, listRes.result, tmpForm, page))
  

  yield put(stopSubmit(`${masterType}MasterForm`))

  yield put(actions.reducerSnackBar(true, '登録しました。', colors.green400))
  yield put(actions.reducerAppLoading(false))

}


const getEndTime = (startTime, endTime) => {

  if (startTime.format('yyyyMMdd') !== endTime.format('yyyyMMdd')) {
    const h = endTime.format('HH');
    const m = endTime.format('mm');
    return (Number(h) + 24) + ":" + m;
  }

  return endTime.format('HH:mm');
}

export function* handleMasterFormEdit(action) {

  yield put(actions.reducerAppLoading(true))

  yield put(startSubmit(`${masterType}MasterForm`))
  yield put(actions.reducerAppLoading(true))

  const {masterType, id} = action.payload
  const res = yield call(commons.get2, `/bg/master/${masterType}/${id}`) 

  const check = yield call(errorCheck, masterType, res)
  if (!check) {
    return
  }

  if (masterType == "overTime") {
    let result = res.result;

    const startTimeMoment = moment(result.startTime, 'YYYY/MM/DD HH:mm:ss')
    const endTimeMoment = moment(result.endTime, 'YYYY/MM/DD HH:mm:ss')

    result.startTime =  startTimeMoment.format('HH:mm')
    result.endTime =  getEndTime(startTimeMoment, endTimeMoment)

    yield put(actions.reducerMasterSetForm(masterType, result))

  } else {
    yield put(actions.reducerMasterSetForm(masterType, res.result))
  }

  yield put(actions.reducerAppLoading(false))

}

export function* handleMasterFormDelete(action) {

  yield put(actions.reducerAppLoading(true))

  const {masterType, id, page, tmpForm} = action.payload
  const deleteRes = yield call(commons.delete2, `/bg/master/${masterType}/${id}`) 

  const check = yield call(errorCheck, masterType, deleteRes)
  if (!check) {
    return
  }

  const listRes = yield call(getList, masterType, page, tmpForm) 

  const listCheck = yield call(errorCheck, masterType, listRes)
  if (!listCheck) {
    return
  }

  yield put(actions.reducerMasterSetList(masterType, listRes.result, tmpForm, page))

  yield put(actions.reducerMasterFormReset(masterType))
  yield put(actions.reducerAppLoading(false))

}


export function* handleMasterSearch(action) {

  const {masterType, page, tmpForm} = action.payload
  
  yield put(startSubmit(`${masterType}MasterForm`))
  yield put(actions.reducerAppLoading(true))

  let res
  if (masterType == 'roumu') {
    res = yield call(commons.post2, `/bg/roumu/approval/search?page=${page}`, tmpForm) 
  } else {
    res = yield call(getList, masterType, page, tmpForm) 
  }

  const check = yield call(errorCheck, masterType, res)
  if (!check) {
    return
  }

  yield put(stopSubmit(`${masterType}MasterForm`))

  if (res.result.count === 0) {
    yield put(actions.reducerSnackBar(true, '検索条件に一致するデータがありません。', colors.blueGrey400))
    yield put(actions.reducerMasterSetList(masterType, res.result, tmpForm, page))
  } else {
    yield put(actions.reducerMasterSetList(masterType, res.result, tmpForm, page))
    yield call(delay, 100)
  }

  yield put(actions.reducerAppLoading(false))

}


// WEBPACK FOOTER //
// ./src/sagas/master.js